<template>
  <div>
    <vue-headful title="E-mail Verificatie" />
    <Header page_title="Bevestigen account" goBackClass="invisible" />
    <div class="d-flex">
      <div class="container-fluid px-4 mx-2">
        <form class="mt-5" @submit.prevent="onSubmit">
          <NotificationContainer />
          <div class="sd-title medium" style="margin-bottom: 20px;">
            Bevestigen account
          </div>
          <p>
            Voer hieronder de code in die we zojuist naar <strong>{{ this.form.email }}</strong> hebben gestuurd.
          </p>
          <div class="form-group sd-input mb-3">
            <label>Code <span class="required">*</span></label>
            <input
              v-on:keypress="isNumber($event)"
              class="form-control"
              placeholder="Code"
              v-model="form.code"
              maxlength="4"
              required
            />
          </div>
          <button
            type="submit"
            class="btn btn-warning btn-block mb-3"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
          >
            Bevestigen
          </button>
          <div class="text-center small">
            <a
              href
              class="text-derect"
              @click.prevent="resendCode"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
            >
              <strong>Code nogmaals versturen</strong>
            </a>
<!--            <a
              href
              class="text-derect"
              @click.prevent="differentEmail"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
            >
              <strong>Geef ander e-mailadres op</strong>
            </a>-->
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      form: {
        email: null,
        code: ""
      },
      type: '',
      success: false,
      error: false
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      const user_login = JSON.parse(localStorage.getItem("user-login"));
      const social_login = JSON.parse(localStorage.getItem("social-login"));
      if (user_login) {
        this.form.email = user_login.email;
      }
      if (social_login) {
        this.form.email = social_login.email;
      }
      if (!this.form.email) {
        this.$router.replace({ name: "splash" });
      }
    },
    async verifyCode() {
      // console.log("async verifyCode()");
      return new Promise(resolve => {
        let formData = new FormData();
        for (var obj in this.form) {
          formData.append(obj, this.form[obj]);
        }
        const url = this.$apiURI + "/auth/verify";
        this.$http
          .post(url, formData, {
            headers: {
              Accept: "application/json"
            }
          })
          .then(resp => {
            localStorage.removeItem("user-redirect");
            //add token here
            localStorage.setItem(
              "user-token",
              JSON.stringify(resp.data.access_token)
            );
            localStorage.setItem("form-pending", JSON.stringify(true));

            if (typeof dataLayer !== "undefined") {
              const isCompany = localStorage.getItem("userType") === "company";
              const dataLayerEvent = isCompany
                ? {
                    event: "SchoolSignUpAccountVerified",
                    eventCategory: "School",
                    eventAction: "School – Sign up account verified",
                    eventLabel: "",
                    eventValue: "1"
                  }
                : {
                    event: "TeacherSignUpAccountVerified",
                    eventCategory: "Teacher",
                    eventAction: "Teacher – Sign up account verified",
                    eventLabel: "",
                    eventValue: "1"
                  };
              dataLayer.push(dataLayerEvent);

              if (isCompany) {
                dataLayer.push({
                  event: "SchoolSignUpAccountCompleted",
                  eventCategory: "School",
                  eventAction: "School - Sign up account completed",
                  eventLabel: "",
                  eventValue: "1"
                });
              }
            }

            resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
          });
      });
    },
    async onSubmit() {
      // console.log("async onSubmit()");
      this.$store.state.loading = true;
      await this.verifyCode();
      localStorage.setItem("user-time", JSON.stringify(new Date()));
      if (localStorage.getItem("userType") !== 'company') {
          const applicantRedirect = (localStorage.getItem('branch') === '3')
              ? 'applicant-step-1-healthcare'
              : 'applicant-step_3';
          await this.userToken(applicantRedirect);
      } else {
          await this.userToken();
      }
    },
    resendCode() {
      // console.log("onResendCode()");
      this.$store.state.loading = true;
      let formData = new FormData();
      formData.append("email", this.form.email);
      const url = this.$apiURI + "/auth/resend";
      this.$http
        .post(url, formData, {
          headers: {
            Accept: "application/json"
          }
        })
        .then(success => {
          // console.log(success);
          this.$store.state.loading = false;
          const notification = {
            type: "success",
            message: success.data.message
          };
          this.$store.dispatch("notification/replace", notification, {
            root: true
          });
          this.$store.state.loading = false;
        })
        .catch(error => {
          // console.log(error);
          const notification = {
            type: "danger",
            message: error.response.data
          };
          this.$store.dispatch("notification/replace", notification, {
            root: true
          });
          this.$store.state.loading = false;
        });
    },
    differentEmail: function() {
      localStorage.removeItem("user-login");
      localStorage.removeItem("user-redirect");
      this.$router.replace({ name: "login" });
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>

<style scoped></style>
